
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/energy-solutions-for-business",
      function () {
        return require("private-next-pages/energy-solutions-for-business/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/energy-solutions-for-business"])
      });
    }
  